<template>
    <div>
        <div id="checkout-page" class="checkout-page-container">
            <checkout-shipping 
             v-if="checkOutStep === shippingStep"
             :createStudio="createStudio"
            />
            <pc-checkout-project-information :user-email="userEmail" v-if="checkOutStep === projectInfoStep"/>
            <pc-checkout-review-basket 
             :listItemTitle="getMainHeading" 
             :createStudio="createStudio"
              v-if="checkOutStep === reviewBasketStep"
            />
            <pc-gtm-event-logger 
                :key="getGtmEventCheckoutItems.length" 
                :eventName="GTMEventName"
                :checkoutProducts="(getGtmEventCheckoutItems || [])"
                 v-if="getGtmEventCheckoutItems !== undefined && getGtmEventCheckoutItems.length > 0"
            />
        </div>
        <shipping-address-modal />
        <address-suggestion-modal />
        <pc-page-loader :loader="loader" />
    </div>
  </template>
  
  <script>
  import { mapGetters, mapActions } from "vuex"; 
  import checkoutShipping from "./checkout-shipping.vue";
  import pcCheckoutProjectInformation from "./pc-checkout-project-information.vue";
  import pcCheckoutReviewBasket from "./pc-checkout-review-basket.vue";
  import pcCheckoutConfirmation from "./pc-checkout-confirmation.vue"
  import pcPageLoader from "../new-basket-page/pc-page-loader.vue";
  import addressSuggestionModal from "./address-suggestion-modal.vue";
  import shippingAddressModal from "./shipping-address-modal.vue"
  import PCGTMEventLogger from "../pc-gtm-event-logger.vue";
  import { CHECKOUT_SHIPPING, CHECKOUT_PROJECT_INFORMATION, CHECKOUT_REVIEW_BASKET } from "../../../constants/checkout-constant";
  import { REVIEW_ORDER_EVENT_NAME } from "../../../constants/gtm-constants";

  export default {
    props: [
        "checkoutdatamodel",
        "maxallowedcartitems",
        "maxfullsizeitems"
    ],
    data() {
      return {
        shippingStep: CHECKOUT_SHIPPING,
        projectInfoStep: CHECKOUT_PROJECT_INFORMATION,
        reviewBasketStep: CHECKOUT_REVIEW_BASKET,
        createStudio: {
            vehicleMake: "",
            vehicleModel: "",
            vehicleColor: "",
            warehouseCode: "",
            deliveryMethod: ""
        },
        userEmail: null,
        GTMEventName: REVIEW_ORDER_EVENT_NAME,
      };
    },
    components: {
        checkoutShipping,
        pcCheckoutProjectInformation,
        pcCheckoutReviewBasket,
        pcCheckoutConfirmation,
        pcPageLoader,
        addressSuggestionModal,
        shippingAddressModal,
        "pc-gtm-event-logger": PCGTMEventLogger,
    },
    watch: {
        checkoutData() {
            if (this.checkoutData.SuccessfulSubmission) {
                this.updateLoader(true)
                let url = new URL(window.location);
                this.$cookies.remove("OrderAddresses");
                this.$cookies.remove("ideaBook");
                window.location.href = url.origin + "/Checkout/OrderConfirmation";
            }
        }
    },
    computed: {
        ...mapGetters({
            checkoutItemList: "newCheckoutPage/checkoutItemList",
            checkoutData: "newCheckoutPage/checkoutData",
            loader: "newCheckoutPage/getLoader",
            checkOutStep: "newCheckoutPage/getCheckOutStep"
        }),
        getGtmEventCheckoutItems() {
            if( this.checkoutItemList && this.checkoutItemList.projectItems && this.checkoutItemList.siteItems && this.checkoutItemList.trayItems) {
                return [].concat( this.checkoutItemList.projectItems, this.checkoutItemList.siteItems, this.checkoutItemList.trayItems)
            } else {
                return []
            }
        },
    },
    methods: {
        ...mapActions({
            updateCheckoutData: "newCheckoutPage/updateCheckoutData",
            updateCheckoutStep: "newCheckoutPage/updateCheckoutStep",
            fetchAddresses: "newCheckoutPage/fetchAddresses",
            getCountryStates: "newCheckoutPage/getCountryStates",
            updateLoader: "newCheckoutPage/updateLoader",
            fetchFullTypeSizeSamples: "newBasketPage/fetchFullTypeSizeSamples",
        }),
        getMainHeading(type) {
            if(type === 0) {
                return this.$resourceString["myBasket.Label.DesignTraySample"]
            } else if(type === 1) {
                return this.$resourceString["myBasket.Label.IndividualSamples"]
            } else if(type === 2) {
                return this.$resourceString["myBasket.Label.ProjectSamples"]
            } else {
                return 'N/A'
            }
        },   
        scrollMethod() {
            let currentScroll = (document.documentElement.scrollTop || document.body.scrollTop);
            const element = document.querySelector(".sidebar-mobile-device");
            if(element) {
                const divTop = element.getBoundingClientRect().top + window.scrollY;
                const windowHeight = window.innerHeight;
                const result = divTop - windowHeight;
                if(currentScroll >= result) {
                    element.classList.remove("__sticky")
                } else {
                    element.classList.add("__sticky")               
                }
            }           
        },        
        async verifyMaxAllowedCartItems() {
            this.updateLoader(true);
            return new Promise(async (resolve) => {
                const fullTypeSizeSamples = await this.fetchFullTypeSizeSamples();
                let siteAndProjectItemsCount = 0;
                let trayItemsCount = 0;
                let isFullSizeQuantityAvailability = false;
                let isSampleAvailability = false;
                this.checkoutdatamodel.Items.forEach((element, index) => {
                    let isFullSize = fullTypeSizeSamples.find(({ Key, Value }) => Key === element.VehicleId && Value === true);
                    if (isFullSize && !this.checkoutdatamodel.IsTrustedUser) { 
                        if(element.SampleAvailability > this.maxfullsizeitems) {
                            this.checkoutdatamodel.Items[index].SampleAvailability = this.maxfullsizeitems
                        }                       
                        if(element.Quantity > this.maxfullsizeitems && !isFullSizeQuantityAvailability) {
                            isFullSizeQuantityAvailability = true
                        }
                    }                 
                    if (element.Item.IsTrayItem) { 
                        trayItemsCount += 1
                    } else { 
                        siteAndProjectItemsCount += 1;
                        if(!isSampleAvailability) {
                            const quantity = this.checkoutdatamodel.Items.reduce((acc, val) => {
                                const isValid = (element.Item.SellingStyleNumber === val.Item.SellingStyleNumber) && (element.Item.SellingColorNumber === val.Item.SellingColorNumber) && (element.VehicleId === val.VehicleId)
                                return isValid ? acc + val.Quantity : acc                          
                            }, 0)                         
                            if(quantity > element.SampleAvailability) {
                                isSampleAvailability = true
                            }
                        }
                    }
                });
                if(siteAndProjectItemsCount > this.maxallowedcartitems || trayItemsCount > this.maxallowedcartitems || isFullSizeQuantityAvailability || isSampleAvailability) {
                    let url = new URL(window.location);
                    window.location.href = url.origin + "/Basket";
                } else {
                    this.updateLoader(false)
                    resolve()
                }
            })
        }
    },
    async mounted() {
        await this.verifyMaxAllowedCartItems();
        this.updateCheckoutStep(CHECKOUT_SHIPPING);               
        await this.fetchAddresses();
        await this.updateCheckoutData(this.checkoutdatamodel);
        await this.getCountryStates("US");
        this.userEmail = this.checkoutdatamodel.Email;
         // sidebaar sticky for bottom
        window.addEventListener("scroll", this.scrollMethod);
        this.resizeObserver = new ResizeObserver(() => this.scrollMethod())
        this.resizeObserver.observe(document.body);
    },
    destroyed(){
        window.removeEventListener("scroll", this.scrollMethod);
        this.resizeObserver.disconnect();
    },
  };
  </script>
  
  <style></style>
  